/**
 * @deprecated Use `RecurrenceFrequency`.
 */
export var ReminderRecurrenceFrequency;
(function (ReminderRecurrenceFrequency) {
    /**
     * @deprecated Use `RecurrenceFrequency.DAILY`.
     */
    ReminderRecurrenceFrequency[ReminderRecurrenceFrequency["DAILY"] = 0] = "DAILY";
    /**
     * @deprecated Use `RecurrenceFrequency.WEEKLY`.
     */
    ReminderRecurrenceFrequency[ReminderRecurrenceFrequency["WEEKLY"] = 1] = "WEEKLY";
    /**
     * @deprecated Use `RecurrenceFrequency.MONTHLY`.
     */
    ReminderRecurrenceFrequency[ReminderRecurrenceFrequency["MONTHLY"] = 2] = "MONTHLY";
    /**
     * @deprecated Use `RecurrenceFrequency.YEARLY`.
     */
    ReminderRecurrenceFrequency[ReminderRecurrenceFrequency["YEARLY"] = 3] = "YEARLY";
})(ReminderRecurrenceFrequency || (ReminderRecurrenceFrequency = {}));
//# sourceMappingURL=reminder-recurrence-frequency.js.map